import { useHighDemand, useOperationalStateTurbo } from './hooks';
import { HighDemandDialog, HighDemandBtn } from './components';

import type { HTMLAttributes } from 'react';

export function HighDemand(props: Props) {
  const { ...extraBtnProps } = props;

  const {
    open,
    isHidden,
    saturation,
    isSingleStore,
    handleOpen,
    handleClose,
    everyIsActive,
  } = useHighDemand();
  const { hasActiveTurboStores, partnerId } = useOperationalStateTurbo();

  if (isHidden) return null;

  return (
    <>
      <HighDemandBtn
        variant={saturation}
        onClick={handleOpen}
        isSingleStore={isSingleStore}
        everyIsActive={everyIsActive}
        hasActiveTurboStores={hasActiveTurboStores}
        {...extraBtnProps}
      />

      {open && (
        <HighDemandDialog
          open={open}
          onClose={handleClose}
          isSingleStore={isSingleStore}
          partnerId={partnerId}
        />
      )}
    </>
  );
}

interface Props extends HTMLAttributes<HTMLDivElement> {}
